import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type StoreDirecitonsResultSkeletonProps = {
    onChangeOriginClick: () => void;
};

export const StoreDirecitonsResultSkeleton = ({
    onChangeOriginClick
}: StoreDirecitonsResultSkeletonProps) => {
    const { t } = useGranite();

    return (
        <>
            <div
                className={cn(
                    "tw:flex tw:gap-2 tw:p-2 tw:border tw:border-primary tw:rounded"
                )}
                onClick={onChangeOriginClick}
            >
                <p
                    className={cn(
                        "tw:flex tw:gap-1 tw:items-center tw:grow tw:shrink tw:basis-full"
                    )}
                >
                    <span
                        className={cn(
                            "tw:bg-grey-light tw:inline-block tw:rounded-sm tw:h-6 tw:w-12.5"
                        )}
                    />
                </p>
                <i
                    className={cn(
                        "las la-lg la-arrow-right",
                        "tw:flex tw:flex-col tw:justify-center"
                    )}
                />
                <p
                    className={cn(
                        "tw:flex tw:gap-1 tw:items-center tw:grow tw:shrink tw:basis-full"
                    )}
                >
                    <span
                        className={cn(
                            "tw:bg-grey-light tw:inline-block tw:rounded-sm tw:h-6 tw:w-12.5"
                        )}
                    />
                </p>
            </div>
            <p className={cn("tw:flex tw:leading-6 tw:my-2 tw:mr-1")}>
                {t("storeDirections.result.routeLength")}
            </p>
            <Button
                type={"button"}
                color={"link"}
                onClick={onChangeOriginClick}
                className={cn("tw:p-0")}
            >
                <i className={"las la-angle-left"} />
                {t("storeDirections.result.changeOrigin")}
            </Button>
        </>
    );
};
